<template>
<span :class="`odr-message odr-message_large odr-message_color-${color} ${withClose ? 'odr-message_large_with-close' : ''}`">
    <tpl :content="title"/>
</span>
</template>

<script>
import '@/scss/blocks/message.scss';
import { coloringMixin } from '@clearwave/odoro-markup/lib/mixins/coloring';

export default {
    mixins: [coloringMixin],
    props: ['title', 'withClose'],
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
    },
};
</script>
